import { Table, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Header = () => {
  const tableTitles: Record<string, string> = {
    company_name: i18n.t('bookkeepers.companies.table.company_name'),
    bookkeepers_count: i18n.t('bookkeepers.companies.table.bookkeepers_count'),
    since: i18n.t('bookkeepers.companies.table.since'),
  }

  return (
    <Table.Head>
      <Table.Row>
        {Object.entries(tableTitles).map(([key, value]) => (
          <Table.HeadCell key={key}>
            <Text.Normal weight="semibold" color="grey800" size="200" whiteSpace="nowrap">
              {value}
            </Text.Normal>
          </Table.HeadCell>
        ))}
      </Table.Row>
    </Table.Head>
  )
}

export default Header
